import ViewModelCore from "./ViewModel";

export default class OrcamentoViewModel extends ViewModelCore{
    constructor (tipoDeFluxo = 0) {
        super();
        this.Amostra = undefined;
        this.AmostraEspecificacaoTecnica = undefined;
        this.CartaPropostaId = undefined;
        this.Cep = undefined;
        this.CidadeId = undefined;
        this.ClienteId = undefined;
        this.CodigoExterno = undefined;
        this.CodigoSistema = undefined;
        this.ComponenteData = [];
        this.ComponenteId = undefined;
        this.ComponenteOrcamentoId = undefined;
        this.Critica1 = undefined;
        this.Critica2 = undefined;
        this.Critica3 = undefined;
        this.Critica4 = undefined;
        this.Critica5 = undefined;
        this.DataDigitacao = undefined;
        this.DataValidade = undefined;
        this.DescricaoAcabamentoFrente = undefined;
        this.DescricaoAcabamentoVerso = undefined;
        this.DescricaoCapaExterna = undefined;
        this.DescricaoCoresFrente = undefined;
        this.DescricaoCoresVerso = undefined;
        this.DescricaoDoPalete = undefined;
        this.DescricaoFrete = undefined;
        this.DescricaoMaterial = undefined;
        this.DescricaoMedidas = undefined;
        this.DescricaoOnda = undefined;
        this.DescricaoOutrasEmbalagens = undefined;
        this.DescricaoOutrasEmbalagensEspecificas = undefined;
        this.DescricaoOutrosMateriais = undefined;
        this.DescricaoPapelOnda = undefined;
        this.DescricaoSequencia = undefined;
        this.DescricaoSistema = undefined;
        this.Embalagem = undefined;
        this.EmbalagemEspecificaCaixaColetiva = undefined;
        this.EmbalagemEspecificaFilmeEncolhivel = undefined;
        this.EmbalagemEspecificaPalete = undefined;
        this.EmpresaId = undefined;
        this.EnderecoId = undefined;
        this.Excluido = undefined;
        this.Exportacao = undefined;
        this.FormatoEspecificacaoTecnica = undefined;
        this.ForneceArquivoDigital = undefined;
        this.ForneceFotolito = undefined;
        this.FSC = undefined;
        this.HoraDigitacao = undefined;
        this.Id = undefined;
        this.IndicadorDeTipoFrete = undefined;
        this.JuncaoPreco = undefined;
        this.Layout = undefined;
        this.Legislacao = undefined;
        this.Lote = undefined;
        this.Nome = undefined;
        this.NomeCidade = undefined;
        this.NomeEmpresa = undefined;
        this.NomeFantasia = undefined;
        this.NomeProduto = undefined;
        this.NomeRepresentante = undefined;
        this.NumeroAltura = undefined;
        this.NumeroAlturaTampa = undefined;
        this.NumeroComprimento = undefined;
        this.NumeroFase = undefined;
        this.NumeroGramaturaCapaExterna = undefined;
        this.NumeroGramaturaCapaInterna = undefined;
        this.NumeroLargura = undefined;
        this.NumeroRepeticoes = undefined;
        this.NumeroSequencia = undefined;
        this.ObservacaoEspecificacaoTecnicaTecnica = undefined;
        this.ObservacoesGerais = undefined;
        this.ObservacoesQuantidade = undefined;
        this.ObservacoesRetorno = undefined;
        this.OrcamentoId = undefined;
        this.OrcamentoParaEmissaoDePedido = undefined;
        this.Outros = undefined;
        this.PapelSeda = undefined;
        this.ProdutoId = undefined;
        this.Prototipo = undefined;
        this.QuantidadeCoresFrente = undefined;
        this.QuantidadeCoresVerso = undefined;
        this.Reorcamento = undefined;
        this.RepresentanteId = undefined;
        this.RiscoFaca = undefined;
        this.Sequencia = undefined;
        this.SiglaEstado = undefined;
        this.Sincronismo = undefined;
        this.Sincronismo = undefined;
        this.Status = undefined;
        this.StatusDigitacao = undefined;
        this.Tipo = undefined;
        this.TipoFluxoOrcamento = tipoDeFluxo;
        this.TipoPalete = undefined;
        this.UsuarioId = undefined;

    }
}